module.exports = __webpack_public_path__ + "media/luxury-2026/waterfront-living-960-a6151e72.jpg";